import { useEffect, useState } from "react";

/**
 * Central breakpoint hook for the workspace UI.
 * Returns { width, isMobile, isTablet, isDesktop, isWide }.
 *
 *   - isMobile  : < 768px
 *   - isTablet  : 768–1023px
 *   - isDesktop : >= 1024px
 *   - isWide    : >= 1440px
 */
export function useBreakpoint() {
  const get = () => (typeof window === "undefined" ? 1200 : window.innerWidth);
  const [w, setW] = useState(get);

  useEffect(() => {
    const onResize = () => setW(get());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  return {
    width: w,
    isMobile: w < 768,
    isTablet: w >= 768 && w < 1024,
    isDesktop: w >= 1024,
    isWide: w >= 1440,
  };
}
